import _ from 'lodash';

export default angular.module('cian.newbuild.filter.sortService', [])
.factory('FilterSortService', [
  'FilterService',
  FilterService => {
    const service = {
      sortItems: undefined,
      sort: {
        type: 'term',
        value: null,
      },
      quality: {
        type: 'term',
        value: null,
      },
    };

    // Генерим список способов сортировки с условиями их отображения
    const sortItems = [
      {
        value: null,
        text: 'По умолчанию',
      },
      {
        value: 'price_object_order',
        text: 'По цене',
      },
      {
        value: 'price_square_order',
        text: 'По цене за квадратный метр',
        checkCondition: () => {
          return FilterService.categoryIs('commercial') ||
            (FilterService.categoryIs('flat') && FilterService.dealTypeIs('sale'));
        },
      },
      {
        value: 'area_order',
        text: FilterService.categoryIs('suburban') ? 'По площади дома' : 'По общей площади',
        checkCondition: () => !FilterService.objectIsSelected('land'),
      },
      {
        value: 'site_order',
        text: 'По площади участка',
        checkCondition: () => FilterService.categoryIs('suburban'),
      },
      {
        value: 'walking_time',
        text: 'По времени до метро',
        checkCondition: () => FilterService.isMetroAvailable() && !FilterService.categoryIs('suburban'),
      },
      {
        value: 'mcad',
        text: 'По расстоянию до МКАД',
        checkCondition: () => FilterService.categoryIs('suburban') && FilterService.isMO(),
      },
      {
        value: 'street_name',
        text: 'По улице',
        checkCondition: () => FilterService.categoryIs('flat'),
      },
      {
        value: 'id_user',
        text: 'По ID',
      }
    ];

    service.updateItems = () => {
      service.sortItems = _.filter(sortItems, item => {
        if (angular.isFunction(item.checkCondition)) {
          return item.checkCondition();
        } else {
          return true;
        }
      });

      // Если в новом наборе нет выбранной сортировки, то сбрасываем на "по умолчанию"
      if (!service.sortItems.some(item => item.value === service.sort.value)) {
        service.sort.value = null;
        service.quality.value = true;
      }
    };

    service.init = (sortVal, qualityVal) => {
      service.sort.value = sortVal;
      service.quality.value = qualityVal;
      service.updateItems();
    };

    service.getSortParams = () => service.sort.value ? {
        sort: angular.copy(service.sort),
        quality: angular.copy(service.quality),
      } : {};

    return service;
  }])
  .name;



// WEBPACK FOOTER //
// ./src/serp/services/filter-sort.service.js